import { DashboardAnalyticsObject } from '@/api/dashboard-analytics'
import { Typography } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { useTranslation } from 'react-i18next'
import GaugeScoremeter from '../GaugeScoremeter/GaugeScoremeter'
import InfoTooltip from '../InfoTooltip/InfoTooltip'
import NoResultsContainer from '../NoResultsContainer/NoResultsContainer'

import noResultsImage from '@/assets/images/flat-smiley.svg'
import CardHeader from '../Card/CardHeader'

type AwarenessScoreProps = {
  score: DashboardAnalyticsObject['awareness_score']
  loading: boolean
}

const AwarenessScore = ({ score, loading = false }: AwarenessScoreProps) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const noData = !loading && (isNaN(score) || score === -1)
  return (
    <div className={classes.root}>
      <div className={classes.slidesContainer}>
        <CardHeader title={t('awarenessMeter.title')}>
          <InfoTooltip title={t('awarenessMeter.tooltip')} sx={{ paddingLeft: '10px' }} />
        </CardHeader>
        {!noData ? <Typography variant={'subtitle2'}>{score}</Typography> : null}
        {noData ? (
          <div style={{ marginTop: 40 }}>
            <NoResultsContainer image={noResultsImage} text={'awarenessScore.noResults'} />
          </div>
        ) : (
          <>
            <div className={classes.scoreMeterContainer}>
              <GaugeScoremeter score={score || 0} hideTitle />
            </div>
          </>
        )}
      </div>
    </div>
  )
}

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    slidesContainer: {
      height: 200,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    scoreMeterContainer: {
      height: 140,
    },
  })
)

export default AwarenessScore
